import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/index';
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};
// 中文
import home from '../pages/home/home';//首页
import feedback from '../pages/feedbackActivity/feedbackActivity';//回馈活动
import productSort from '../pages/productCenter/productSort';//产品中心
import productList from '../pages/productCenter/productList';//产品中心-商品列表
import productDetail from '../pages/productCenter/productDetail';//产品中心-商品详情
import origin from '../pages/historyCulture/origin';//历史文化-历史渊源
import account from '../pages/historyCulture/account';//历史文化-天益老号
import museum from '../pages/historyCulture/museum';//历史文化-博物馆
import natural from '../pages/craft/natural';//工艺优胜-自然美景
import brew from '../pages/craft/brew';//工艺优胜-酿造工艺
import inherit from '../pages/craft/inherit';//工艺优胜-传承发展
import news from '../pages/news/news';//新闻资讯
import newsList from '../pages/news/newsList';//新闻资讯-列表
import newsDetail from '../pages/news/newsDetail';//新闻资讯-详情
import newssearch from '../pages/news/newssearch';//新闻搜索
import allList from '../pages/news/allList';//手机端查看全部
import about from '../pages/about/profile';//关于我们-公司简介
import honor from '../pages/about/honor';//关于我们-企业荣誉
import seAll from '../pages/security/seAll';//防伪查询-全新三位一体查询
import seNews from '../pages/security/seNews';//防伪查询-全新三位一体查询
import seOld from '../pages/security/seOld.vue';//防伪查询-三重八关防伪体系
import join from '../pages/join/join';//招商加盟
import applyForm from '../pages/join/applyForm';//招商加盟-申请表单
import contact from '../pages/contact/contact';//联系我们
import shop from '../pages/shop/shop';//专卖店查询
import shopareas from '../pages/shop/shopareas';//专卖店查询
import shopList from '../pages/shop/shopList';//专卖店查询

//英文
import enHome from '../english/home/home';//首页
import advantage from '../english/advantage/advantage';//核心优势（英文页面）
import search from '../english/enSearch/search';//核心优势（英文搜索页面）
import enAbout from '../english/about/about';//关于我们
import enProductSort from '../english/productCenter/productSort';
import enProductDetail from '../english/productCenter/productDetail';
import historyCulture from '../english/historyCulture/historyCulture';
import enContact from '../english/contact/contact';


Vue.use(Router);

const router = new Router({
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
           return savedPosition;
        } else {
           return { x: 0, y: 0 };
        }
    },
    mode: 'history',
    routes: [{
            path: '/',
            name: 'home',
            component: home,
            meta: {
                show: true
            }
        },
        {
            path: '/feedback',
            name: 'feedback',
            component: feedback,
            meta: {
                show: true
            }
        },
        {
            path: '/productSort',
            name: 'productSort',
            component: productSort,
            meta: {
                show: true
            }
        },
        {
            path: '/productList',
            name: 'productList',
            component: productList,
            meta: {
                show: true
            }
        },
        {
            path: '/productDetail',
            name: 'productDetail',
            component: productDetail,
            meta: {
                show: true
            }
        },
        {
            path: '/origin',
            name: 'origin',
            component: origin,
            meta: {
                show: true
            }
        },
        {
            path: '/account',
            name: 'account',
            component: account,
            meta: {
                show: true
            }
        },
        {
            path: '/museum',
            name: 'museum',
            component: museum,
            meta: {
                show: true
            }
        },
        {
            path: '/natural',
            name: 'natural',
            component: natural,
            meta: {
                show: true
            }
        },
        {
            path: '/brew',
            name: 'brew',
            component: brew,
            meta: {
                show: true
            }
        },
        {
            path: '/inherit',
            name: 'inherit',
            component: inherit,
            meta: {
                show: true
            }
        },
        {
            path: '/news',
            name: 'news',
            component: news,
            meta: {
                show: true
            }
        },
        {
            path: '/newsList',
            name: 'newsList',
            component: newsList,
            meta: {
                show: true
            }
        },
        {
            path: '/newsDetail',
            name: 'newsDetail',
            component: newsDetail,
            meta: {
                show: true
            }
        },
        {
            path: '/newssearch',
            name: 'newssearch',
            component: newssearch,
            meta: {
                show: true
            }
        },
        {
            path: '/allList',
            name: 'allList',
            component: allList,
            meta: {
                show: true
            }
        },
        {
            path: '/about',
            name: 'about',
            component: about,
            meta: {
                show: true
            }
        },
        {
            path: '/honor',
            name: 'honor',
            component: honor,
            meta: {
                show: true
            }
        },
        {
            path: '/seAll',
            name: 'seAll',
            component: seAll,
            meta: {
                show: true
            }
        },
        {
            path: '/seNews',
            name: 'seNews',
            component: seNews,
            meta: {
                show: true
            }
        },
        {
            path: '/seOld',
            name: 'seOld',
            component: seOld,
            meta: {
                show: true
            }
        },
        {
            path: '/join',
            name: 'join',
            component: join,
            meta: {
                show: true
            }
        },
        {
            path: '/applyForm',
            name: 'applyForm',
            component: applyForm,
            meta: {
                show: true
            }
        },
        {
            path: '/contact',
            name: 'contact',
            component: contact,
            meta: {
                show: true
            }
        },
        {
            path: '/shop',
            name: 'shop',
            component: shop,
            meta: {
                show: true
            }
        },
        {
            path: '/shopareas',
            name: 'shopareas',
            component: shopareas,
            meta: {
                show: true
            }
        },
        {
            path: '/shopList',
            name: 'shopList',
            component: shopList,
            meta: {
                show: true
            }
        },
        /* 英文链接 */
        {
            path: '/en/home',
            name: 'enHome',
            component: enHome,
            meta: {
                show: true
            }
        },
        {
            path: '/en/advantage',
            name: 'advantage',
            component: advantage,
            meta: {
                show: true
            }
        },
        {
            path: '/en/search',
            name: 'search',
            component: search,
            meta: {
                show: true
            }
        },
        {
            path: '/en/about',
            name: 'enAbout',
            component: enAbout,
            meta: {
                show: true
            }
        },
        {
            path: '/en/productSort',
            name: 'enProductSort',
            component: enProductSort,
            meta: {
                show: true
            }
        },
        {
            path: '/en/productDetail',
            name: 'enProductDetail',
            component: enProductDetail,
            meta: {
                show: true
            }
        },
        {
            path: '/en/historyCulture',
            name: 'historyCulture',
            component: historyCulture,
            meta: {
                show: true
            }
        },
        {
            path: '/en/contact',
            name: 'enContact',
            component: enContact,
            meta: {
                show: true
            }
        },
    ]
});
function detectDevice() {
    const userAgent = navigator.userAgent;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
}
// 全局后置钩子
router.afterEach((to, from) => {
    var isPhone = detectDevice();
    var pth = to.path;
    // 根据
    if(pth=='/en/home'||pth=='/en/about'||pth=='/en/productSort'||pth=='/en/productDetail'||pth=='/en/historyCulture'||pth=='/en/advantage'||pth=='/en/contact'||pth=='/en/search'){
        store.commit('GETLAN',2);
    }else{
        store.commit('GETLAN',1);
    }

    if(isPhone){//手机端
        store.commit('SET_CURRENT_TAB', null);
        store.commit('HEAD_NAV', 999);
        if(pth=='/seAll'){
            store.commit('SET_CURRENT_TAB2', 0);
        }
        if(pth=='/join'){
            store.commit('SET_CURRENT_TAB2', 1);
        }
        if(pth=='/contact'){
            store.commit('SET_CURRENT_TAB2', 2);
        }
        if(pth=='/shopareas'){
            store.commit('SET_CURRENT_TAB2', 4);
        }
        if(pth!='/seAll'&&pth!='/join'&&pth!='/contact'&&pth!='/shopareas'){
            store.commit('SET_CURRENT_TAB2', null);
        }
    }else{
        // 头部
        if(pth=='/'){
            store.commit('HEAD_NAV', 0);
            store.commit('SET_CURRENT_TAB', null);
        }
        if(pth=='/feedback'){
            store.commit('HEAD_NAV', 1);
            store.commit('SET_CURRENT_TAB', null);
        }
        if(pth=='/productSort'){
            store.commit('HEAD_NAV', 2);
            store.commit('SET_CURRENT_TAB', null);
        }
        if(pth=='/productList'||pth=='/productDetail'){
            store.commit('HEAD_NAV', 999);
            store.commit('SET_CURRENT_TAB', null);
        }
        if(pth=='/origin'||pth=='/account'||pth=='/museum'){
            store.commit('HEAD_NAV', 3);
            store.commit('SET_CURRENT_TAB', null);
        }
        if(pth=='/natural'||pth=='/brew'||pth=='/inherit'){
            store.commit('HEAD_NAV', 4);
            store.commit('SET_CURRENT_TAB', null);
        }
        if(pth=='/news'||pth=='/newsDetail'||pth=='newssearch'){
            store.commit('HEAD_NAV', 5);
            store.commit('SET_CURRENT_TAB', null);
        }
        if(pth=='/about'||pth=='/honor'){
            store.commit('HEAD_NAV', 6);
            store.commit('SET_CURRENT_TAB', null);
        }
        // 底部
        if(pth=='/seAll'||pth=='/seNews'||pth=='/seOld'){
            store.commit('HEAD_NAV', 999);
            store.commit('SET_CURRENT_TAB', 0);
        }
        if(pth=='/shop'){
            store.commit('HEAD_NAV', 999);
            store.commit('SET_CURRENT_TAB', 1);
        }
        if(pth=='/join'||pth=='/applyForm'){
            store.commit('HEAD_NAV', 999);
            store.commit('SET_CURRENT_TAB', 2);
        }
        if(pth=='/contact'){
            store.commit('HEAD_NAV', 999);
            store.commit('SET_CURRENT_TAB', 3);
        }
        // 英文
        if(pth=='/en/home') store.commit('HEAD_NAVEN', 0);
        if(pth=='/en/about') store.commit('HEAD_NAVEN', 1);
        if(pth=='/en/productSort') store.commit('HEAD_NAVEN', 2);
        if(pth=='/en/productDetail') store.commit('HEAD_NAVEN', 2);
        if(pth=='/en/historyCulture') store.commit('HEAD_NAVEN', 3);
        if(pth=='/en/advantage') store.commit('HEAD_NAVEN', 4);
        if(pth=='/en/contact') store.commit('HEAD_NAVEN', 5);
        if(pth=='/en/search') store.commit('HEAD_NAVEN', null);
    }
})
export default router